module.exports = __webpack_public_path__ + "static/media/maja_polish.6d84b2f6.mp3";